import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import SimpleArtist from '@common/types/artist/simple-artist';
import { SimpleRelease } from '@common/types/release/simple-release';

import CollapsableBox from '@webapp/controllers/collapsable-box';
import CoverInfo from '@webapp/controllers/analytics/cover-info';
import { Dispatch } from 'redux';
import { ListMultipleArtistsReleases } from '../../../store/release/action-creators';

interface UserArtistListProps {
  artists: SimpleArtist[];
  releases: {[artistId: string] : SimpleRelease[] };
  getArtistsReleases: (ids: string[]) => ListMultipleArtistsReleases;
}

const mapStateToProps = (state: AppState) => ({
  artists: state.artist.myArtists,
  releases: state.release.artistMap,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getArtistsReleases: (ids: string[]) => dispatch(new ListMultipleArtistsReleases(ids))
})

export const UserArtistList: React.FC<UserArtistListProps> = ({
  artists,
  getArtistsReleases,
  releases,
}) => {

  React.useEffect(() => {
    getArtistsReleases(artists.map((a) => a.id));
  }, [artists, getArtistsReleases])

  return (
    <>
      {artists.map((artist) => {
        const artistReleases = releases[artist.id] || [];

        return (
          <StyledCollapsableBox title={artist.name} text={`${artistReleases.length} release${artistReleases.length !== 1 ? 's' : ''}`} key={artist.id}>
            <ReleasesWrapper>
              {
                artistReleases.map((release) => (
                  <CoverInfo
                    key={release.id}
                    className='cover-info'
                    srcImg={release.cover.url}
                    title={release.title}
                  />
                ))
              }
            </ReleasesWrapper>
          </StyledCollapsableBox>
        )
      }
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserArtistList);

const StyledCollapsableBox = styled(CollapsableBox)`
  margin-bottom: 8px;

  @media ${({ theme }) => theme.device.laptopS} {
    margin-bottom: 15px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const ReleasesWrapper = styled.div`
  .cover-info {
    padding: 15px 0;
    border-bottom: 1px dotted ${({ theme }) => theme.colors.border};

    @media ${({ theme }) => theme.device.laptopS} {
      padding: 30px 0;
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;
